module.exports = __webpack_public_path__ + "static/img/11.b568b65.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/1/eng/11.png
// module id = 7khC
// module chunks = 0